@if (formattedPageSizeOptions) {
  <mat-paginator #planSummaryListPaginator
    [length]="totalLength"
    [pageSize]="pageSize"
    [pageSizeOptions]="formattedPageSizeOptions"
    (page)="change($event)">
  </mat-paginator>
}
